import { useEffect, useRef } from 'react';
import eventAnalyticsApi from 'api/requests/eventAnalytics';
import { getAnalyticsSessionId } from 'scripts/analyticsSession';

const TRACKED_KEY_PREFIX = 'event_view_tracked_';

/**
 * Registra 1 view por evento por aba. Dois casos não podem contar em dobro:
 * o StrictMode remonta o efeito em dev (monta → limpa → monta de novo), e o
 * visitante pode voltar pra mesma página pelo back/forward do navegador sem
 * sair da aba. sessionStorage cobre os dois — é lido e marcado antes do POST
 * sair, e expira sozinho quando a aba fecha, então uma aba nova (ou amanhã)
 * conta como view de novo.
 */
export default function useEventPageTracking(eventId) {
    const firedRef = useRef(null);

    useEffect(() => {
        if (!eventId || firedRef.current === eventId) {
            return;
        }

        firedRef.current = eventId;

        const key = `${TRACKED_KEY_PREFIX}${eventId}`;

        try {
            if (sessionStorage.getItem(key)) {
                return;
            }
            sessionStorage.setItem(key, '1');
        } catch {
            // sessionStorage indisponível: segue sem dedupe entre navegações,
            // o firedRef acima ainda protege o retrigger do StrictMode.
        }

        eventAnalyticsApi.track(eventId, 'view', getAnalyticsSessionId()).catch(() => {});
    }, [eventId]);
}
